export const verificaScreen = async(screen, location) => {
    return location?.pathname.includes(`/${screen}`); 
};